import React from 'react';
import { PauseIcon, PlayIcon } from '@radix-ui/react-icons';

import styles from './circular-progress-bar.module.scss';
type ProgressIndicatorProps = {
  progress: number;
  onPause?: () => void;
  onResume?: () => void;
  status?: string;
  displayProgress?: boolean;
  controlsAlwaysDisplayed?: boolean;
  className?: string;
};

export const CircularProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  progress,
  status,
  onPause,
  onResume,
  displayProgress,
  controlsAlwaysDisplayed,
  className,
}) => {
  return (
    <div
      className={
        className
          ? `${styles['circular-progress-bar']} ${className}`
          : styles['circular-progress-bar']
      }
      style={{ '--progress-percent': `${progress}%` } as React.CSSProperties}
      data-controls={!!controlsAlwaysDisplayed}
    >
      {displayProgress && <span className={status ? 'progress' : ''}>{progress}%</span>}
      {status !== 'paused' && onPause && (
        <PauseIcon
          className={'action'}
          onClick={(e) => {
            e.stopPropagation();
            onPause();
          }}
        />
      )}
      {status === 'paused' && onResume && (
        <PlayIcon
          className={'action'}
          onClick={(e) => {
            e.stopPropagation();
            onResume();
          }}
        />
      )}
    </div>
  );
};
